<template>
  <RightInfoPanelGeneric
    :value="value"
    :title-key="'stock_management.contracts_purchase_sale.title_info_date'"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('back')"
  />
</template>

<script>
import RightInfoPanelGeneric from "@/components/Common/RightInfoPanelGeneric.vue";

export default {
  name: "ContractsPurchaseSaleRightPanel",
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      const isSaleIntragroup = this.value?.sale_type === "intragroup";

      return [
        {
          labelKey: "stock_management.contracts_purchase_sale.contract_type",
          path: "contract_type",
          required: true,
        },
        {
          labelKey: "stock_management.contracts_purchase_sale.date",
          path: "date",
          required: true,
        },
        {
          labelKey: "common.legal_entity_name",
          path: "legal_entity_name",
          required: true,
        },
        isSaleIntragroup
          ? {
              labelKey: "stock_management.contracts_purchase_sale.intragroup",
              path: "intragroup_legal_entity_name",
              required: true,
            }
          : {
              labelKey: "common.partner",
              path: "partner_name",
              required: true,
            },
        {
          labelKey: "stock_management.contracts_purchase_sale.contract_number",
          path: "contract_number",
          required: true,
        },
        {
          labelKey: "common.product",
          path: "products",
          required: true,
          formatter: (val) => {
            const count = Array.isArray(val) ? val.length : 0;
            if (!count) return "*";
            return "" + count + (count === 1 ? " produs selectat" : " produse selectate");
          },
        },
      ];
    },
  },
};
</script>
